import React, { createContext, useState, useContext, useEffect } from "react";

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const STORAGE_KEY = "favorites"; // Definição da chave do localStorage

  // Carrega os favoritos do localStorage ao iniciar
  const loadFavoritesFromStorage = () => {
    try {
      const storedFavorites = localStorage.getItem(STORAGE_KEY);
      return storedFavorites ? JSON.parse(storedFavorites) : [];
    } catch (error) {
      console.error("Erro ao carregar favoritos do localStorage:", error);
      return [];
    }
  };

  const [favorites, setFavorites] = useState(loadFavoritesFromStorage);
  const [filters, setFilters] = useState([]);
  // searchApplied só vira true quando o usuário efetivamente clica em
  // "Mostrar imóveis" no FilterModal — diferencia uma pesquisa real de
  // filters.results já estar populado só porque o FilterModal montou.
  const [searchApplied, setSearchApplied] = useState(false);
  // Vive no contexto (em vez de estado local do Header) para que qualquer
  // página — ex. o botão "Editar busca" em /pesquisa — possa reabrir o
  // mesmo FilterModal sem duplicar o modal em outro lugar.
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  // Atualiza o localStorage sempre que os favoritos mudam
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.error("Erro ao salvar favoritos no localStorage:", error);
    }
  }, [favorites]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === STORAGE_KEY) {
        try {
          const updatedFavorites = event.newValue ? JSON.parse(event.newValue) : [];
          setFavorites(updatedFavorites);
        } catch (error) {
          console.error("Erro ao sincronizar favoritos entre abas:", error);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const addFavorite = (property) => {
    if (!favorites.some((fav) => fav.imovelInfo.codigo === property.imovelInfo.codigo)) {
      const updatedFavorites = [...favorites, property];
      setFavorites(updatedFavorites);
    }
  };

  const removeFavorite = (codigo) => {
    const updatedFavorites = favorites.filter((fav) => fav.imovelInfo.codigo !== codigo);
    setFavorites(updatedFavorites);
  };

  // Reseta o estado de busca (usado tanto por "Limpar Filtros" dentro do
  // FilterModal quanto por "Limpar busca" em /pesquisa) — mantém os dois
  // pontos de entrada consistentes sem duplicar a lógica.
  const clearSearch = () => {
    setSearchApplied(false);
    setFilters((prev) => ({
      ...(Array.isArray(prev) ? {} : prev),
      results: [],
      criteria: null,
    }));
  };

  return (
    <FavoritesContext.Provider value={{
      favorites,
      addFavorite,
      removeFavorite,
      setFilters,
      filters,
      searchApplied,
      setSearchApplied,
      clearSearch,
      isFilterModalOpen,
      setIsFilterModalOpen,
    }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
